import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setCardFront, setCardBack } from "../../redux/insuranceSlice";
import Question from "../../components/Question";
import ContinueButton from "../../components/ContinueButton";
import ImageUpload from "../../components/ImageUpload";
import { Box, Typography, FormLabel, Grid, useTheme, useMediaQuery } from "@mui/material";
import useImageDownload from "../../hooks/useImageDownload";
import { continueButtonSx } from "../../lib/uiformatting";
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

export default function InsurancePhoto() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { returning = false } = location.state || {};
    const insurance = useSelector((state) => state.insurance);

    const frontCardFile = useImageDownload(insurance.cardFront && insurance.cardFront[0]);
    const backCardFile = useImageDownload(insurance.cardBack && insurance.cardBack[0]);

    const handleCardFrontUpload = (files) => {
        dispatch(setCardFront(files));
    };

    const handleCardBackUpload = (files) => {
        dispatch(setCardBack(files));
    };

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));

    const handleNext = () => {
        if (returning) {
            setPageAndDeferNavigate(dispatch, '/anything-else-toknow', () =>
                navigate('/anything-else-toknow', { state: { returning: true } })
            );
        } else {
            setPageAndDeferNavigate(dispatch, '/whats-next', navigate);
        }
    };

    const handleBack = () => {
        setPageAndDeferNavigate(dispatch, '/insurance/method', navigate);
    };

    return (
        <Question
            onBack={handleBack}
            title="Great! Take a photo or upload one of the insurance card."
            subtitle="This gives us everything needed without you having to type it out."
            returning={returning}
            input={
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1.5rem",
                        width: "100%",
                        maxWidth: isDesktop ? "600px" : "100%",
                        margin: "0 auto",
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <FormLabel id="front-card-label">
                                <Typography variant="h6" sx={{ mb: "1rem" }}>
                                    Insurance Card Front *
                                </Typography>
                            </FormLabel>
                            <ImageUpload
                                multiple={false}
                                required={true}
                                files={returning && frontCardFile ? [frontCardFile] : insurance.cardFront}
                                setFiles={handleCardFrontUpload}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormLabel id="back-card-label">
                                <Typography variant="h6" sx={{ mb: "1rem" }}>
                                    Insurance Card Back
                                </Typography>
                            </FormLabel>
                            <ImageUpload
                                multiple={false}
                                files={returning && backCardFile ? [backCardFile] : insurance.cardBack}
                                setFiles={handleCardBackUpload}
                            />
                        </Grid>
                    </Grid>
                </Box>
            }
            footer={
                <Box
                    sx={{
                        ...continueButtonSx,
                        position: "sticky",
                        bottom: 0,
                    }}
                >
                    <ContinueButton
                        onClick={handleNext}
                        title="Continue"
                        disabled={!insurance.cardFront || insurance.cardFront.length === 0}
                        selected={!!insurance.cardFront && insurance.cardFront.length > 0}
                    />
                </Box>
            }
        />
    );
}
